import 'regenerator-runtime/runtime';
import { put, call, takeEvery, takeLatest, all } from 'redux-saga/effects';
import {
  getById,
  search,
  create,
  importLot,
  update,
  selectRoom,
  selectTrade,
  getLotTab,
  checkHomeownerExistingByEmail,
  inviteHomeowner,
  setNewOwnershipToLot,
  updatePurchaseDateToLot,
  addMoreHomeownerToLot,
  resetPrimaryHomeownerToLot,
  getHomeownerLotList,
  getHomeownerLotDetail,
  searchRFSLot,
  searchHomeownerRFSLot,
  setupLotDocumentAWS,
  uploadLotDocumentToS3,
  uploadLotDocumentToServer,
  getLotDocument,
  downloadLotDocument,
  removeLotDocument,
  getLotNotes,
  addLotNotes,
  editLotNotes,
  checkTenancyExistingByEmail,
  setNewLotTenancy,
  inviteLotTenancy,
  setLotPrimaryContact,
  removeTenancy,
  deleteLotNotes,
  getHomeownerLotDocument,
  setupHomeownerLotDocumentAWS,
  getLotLocations,
  getHomeownerLotLocations,
  getSelectListHomeownerLot,
  getListHomeownerDocumentType,
  getHomeownerDocumentByDocumentType,
  exportLotList,
  getSubcontractorLotDetail,
  getSelectCostCode,
  setAllWarrantyAccessToHomeowner,
  getHomeownerHomeInventoryCategories,
  getHomeownerHomeInventoryCategoryItems,
  getHomeownerHomeInventoryCategoryItemsProfile,
  editHomeownerHomeInventoryCategoryItemsProfile,
  getCategoryProfileDetails,
  getTaskReminderListForHomeowner,
  updateTaskReminderWithId,
  updateTaskReminderWithoutId
} from './api';

import * as LotActionType from './constants';
import * as NotifyActionType from '../Notification/constants';

export function* createAsync(action) {
  const result = yield call(create, action.params.data);

  const statusCode = result.statusCode;

  if (statusCode === 200) {
    if (action.paramFilter) {
      yield put({
        type: LotActionType.SEARCH_LOT_ASYNC,
        params: action.paramFilter
      });
    }
    yield [
      // put({ type: LotActionType.GET_LOT_TAB_ASYNC, params: action.params.search }),
      put({ type: LotActionType.CREATE_UPDATE_SUCCESS }),
      put({ type: NotifyActionType.NOTIFY_SUCCESS, data: 'Lot added.' })
    ];
    if (action.callback) {
      action.callback();
    }
  } else {
    yield put({
      type: LotActionType.CREATE_UPDATE_LOT_ERROR,
      data: { error: result.data.error, params: action.params.data }
    });
    // yield put({ type: NotifyActionType.NOTIFY_ERROR, data: result.data.error });
  }
}

export function* updateAsync(action) {
  const result = yield call(update, action.params);

  const statusCode = result.statusCode;

  if (statusCode === 200) {
    yield [
      put({ type: LotActionType.GET_LOT_BY_ID_SUCCESS, data: result.data }),
      put({ type: NotifyActionType.NOTIFY_SUCCESS, data: 'Saved' })
    ];
    if (action.callback) {
      action.callback();
    }
  } else {
    yield put({
      type: LotActionType.CREATE_UPDATE_LOT_ERROR,
      data: { error: result.data, params: action.params.data }
    });
  }
}

export function* searchAsync(action) {
  const result = yield call(search, action.params);
  const statusCode = result.statusCode;
  if (statusCode === 200) {
    yield put({
      type: LotActionType.SEARCH_LOT_SUCCESS,
      data: {
        data: result.data,
        params: action.params
      }
    });

    if (action.callback) {
      action.callback();
    }
  } else {
    yield put({ type: NotifyActionType.NOTIFY_ERROR, data: result.data });
  }
}

export function* getByIdAsync(action) {
  const result = yield call(getById, action.params);

  const statusCode = result.statusCode;

  if (statusCode === 200) {
    yield put({ type: LotActionType.GET_LOT_BY_ID_SUCCESS, data: result.data });
    if (action.callback) {
      action.callback();
    }
  } else {
    yield put({ type: NotifyActionType.NOTIFY_ERROR, data: result.data });
  }
}

export function* importLotAsync(action) {
  const result = yield call(importLot, action.params);

  const statusCode = result.statusCode;

  if (statusCode === 200) {
    yield put({
      type: LotActionType.IMPORT_LOT_SUCCESS,
      data: result.data
    });
  } else {
    yield put({ type: LotActionType.IMPORT_LOT_FAIL, data: result.data });
  }
}

export function* selectRoomAsync(action) {
  const result = yield call(selectRoom, action.params);

  const statusCode = result.statusCode;

  if (statusCode === 200) {
    yield put({
      type: LotActionType.SELECT_ROOM_SUCCESS,
      data: result.data
    });
    if (action.callback) {
      action.callback(result.data);
    }
  } else {
    yield put({ type: NotifyActionType.NOTIFY_ERROR, data: result.data });
  }
}

export function* selectTradeAsync(action) {
  const result = yield call(selectTrade, action.params);

  const statusCode = result.statusCode;

  if (statusCode === 200) {
    yield put({
      type: LotActionType.SELECT_TRADE_SUCCESS,
      data: result.data
    });
    if (action.callback) {
      action.callback(result.data);
    }
  } else {
    yield put({ type: NotifyActionType.NOTIFY_ERROR, data: result.data });
  }
}

export function* getLotTabAsync(action) {
  const result = yield call(getLotTab, action.params);
  const statusCode = result.statusCode;

  if (statusCode === 200) {
    yield [
      put({
        type: LotActionType.SEARCH_LOT_SUCCESS,
        data: {
          data: result.data,
          params: action.params
        }
      })
    ];
  } else {
    yield put({ type: NotifyActionType.NOTIFY_ERROR, data: result.data });
  }
}

export function* checkHomeownerExistingByEmailAsync(action) {
  const result = yield call(checkHomeownerExistingByEmail, action.params);
  const statusCode = result.statusCode;

  if (statusCode === 200) {
    const { data } = result;
    if (data.hasOwnerOwnerShip) {
      const type = 0; //The email address is the lot's current owner
      action.callback(type, data);
    } else if (data.hasExisted && data.hasBelongBuilder) {
      const type = 1; //The email address appears as a homeowner user that has already been used by current builder
      action.callback(type, data);
    } else if (data.hasExisted && !data.hasBelongBuilder) {
      const type = 2; //The email address appears as an existing user but it has NOT been used by current builder as a homeowner
      action.callback(type, data);
    } else if (!data.hasExisted) {
      const type = 3; //The email address does not exist in entire system
      action.callback(type, data);
    }
  } else {
    yield put({ type: NotifyActionType.NOTIFY_ERROR, data: result.data.error });
  }
}

export function* inviteHomeownerAsync(action) {
  const result = yield call(inviteHomeowner, action.params);
  const statusCode = result.statusCode;

  if (statusCode === 200) {
    yield [
      // put({ type: LotActionType.INVITE_HOMEOWNER_SUCCESS, data: result.data }),
      put({ type: NotifyActionType.NOTIFY_SUCCESS, data: 'Saved' })
    ];
    if (action.callback) {
      action.callback();
    }
  } else {
    yield put({ type: NotifyActionType.NOTIFY_ERROR, data: result.data.error });
  }
}

export function* setNewOwnershipToLotAsync(action) {
  const result = yield call(setNewOwnershipToLot, action.params);
  const statusCode = result.statusCode;

  if (statusCode === 200) {
    yield [put({ type: NotifyActionType.NOTIFY_SUCCESS, data: 'Saved' })];
    if (action.callback) {
      action.callback();
    }
  } else {
    yield put({ type: NotifyActionType.NOTIFY_ERROR, data: result.data.error });
  }
}

export function* updatePurchaseDateToLotAsync(action) {
  const result = yield call(updatePurchaseDateToLot, action.params);
  const statusCode = result.statusCode;

  if (statusCode === 200) {
    yield [
      put({ type: LotActionType.GET_LOT_BY_ID_SUCCESS, data: result.data }),
      put({ type: NotifyActionType.NOTIFY_SUCCESS, data: 'Saved' })
    ];
    if (action.callback) {
      action.callback();
    }
  } else {
    yield put({ type: NotifyActionType.NOTIFY_ERROR, data: result.data.error });
  }
}

export function* addMoreHomeownerToLotAsync(action) {
  const result = yield call(addMoreHomeownerToLot, action.params);
  const statusCode = result.statusCode;

  if (statusCode === 200) {
    yield [put({ type: NotifyActionType.NOTIFY_SUCCESS, data: 'Saved' })];
    if (action.callback) {
      action.callback();
    }
  } else {
    yield put({ type: NotifyActionType.NOTIFY_ERROR, data: result.data.error });
  }
}

export function* resetPrimaryHomeownerToLotAsync(action) {
  const result = yield call(resetPrimaryHomeownerToLot, action.params);
  const statusCode = result.statusCode;

  if (statusCode === 200) {
    yield [
      put({ type: LotActionType.GET_LOT_BY_ID_SUCCESS, data: result.data }),
      put({ type: NotifyActionType.NOTIFY_SUCCESS, data: 'Saved' })
    ];
    if (action.callback) {
      action.callback();
    }
  } else {
    yield put({ type: NotifyActionType.NOTIFY_ERROR, data: result.data.error });
  }
}

export function* getHomeownerLotDetailAsync(action) {
  const result = yield call(getHomeownerLotDetail, action.params);
  const statusCode = result.statusCode;
  if (statusCode === 200) {
    yield put({ type: LotActionType.GET_LOT_BY_ID_SUCCESS, data: result.data });
    if (action.callback) {
      action.callback();
    }
  } else {
    yield put({ type: NotifyActionType.NOTIFY_ERROR, data: result.data.error });
  }
}

export function* getSubcontractorLotDetailAsync(action) {
  const result = yield call(getSubcontractorLotDetail, action.params);
  const statusCode = result.statusCode;
  if (statusCode === 200) {
    yield put({ type: LotActionType.GET_LOT_BY_ID_SUCCESS, data: result.data });
  } else {
    yield put({ type: NotifyActionType.NOTIFY_ERROR, data: result.data.error });
  }
}

export function* getHomeownerLotListAsync(action) {
  const result = yield call(getHomeownerLotList, {});
  const statusCode = result.statusCode;
  if (statusCode === 200) {
    yield put({
      type: LotActionType.GET_HOMEOWNER_LOT_LIST_SUCCESS,
      data: result.data
    });
    // if (result.data.length === 1 && action.callbackRedirectToLotDetail) {
    //   action.callbackRedirectToLotDetail(result.data[0].lot.id);
    // }

    if (action.callbackSetLotDetail) {
      const { lotId } = action.params;
      const lotFound = result.data.find(item => item.lot.id === lotId);
      action.callbackSetLotDetail(lotFound);
    }

    if (action.callbackGetBuilderProfile) {
      const { lotId } = action.params;
      const lotFound = result.data.find(item => item.lot.id === lotId);
      action.callbackGetBuilderProfile(lotFound.builderProfile);
    }
  } else {
    yield put({ type: NotifyActionType.NOTIFY_ERROR, data: result.data });
  }
}

export function* searchRFSLotAsync(action) {
  const result = yield call(searchRFSLot, action.params);
  const statusCode = result.statusCode;
  if (statusCode === 200) {
    yield put({
      type: LotActionType.SEARCH_RFS_LOT_SUCCESS,
      data: {
        data: result.data,
        params: action.params.param
      }
    });
  } else {
    yield put({ type: NotifyActionType.NOTIFY_ERROR, data: result.data });
  }
}

export function* searchHomeownerRFSLotAsync(action) {
  const result = yield call(searchHomeownerRFSLot, action.params);
  const statusCode = result.statusCode;
  if (statusCode === 200) {
    yield put({
      type: LotActionType.SEARCH_RFS_LOT_SUCCESS,
      data: {
        data: result.data,
        params: action.params.param
      }
    });
  } else {
    yield put({ type: NotifyActionType.NOTIFY_ERROR, data: result.data });
  }
}

export function* setupLotDocumentAWSAsync(action) {
  const result = yield call(setupLotDocumentAWS, action.params);
  const statusCode = result.statusCode;
  if (statusCode === 200) {
    yield put({
      type: LotActionType.SETUP_LOT_DOCUMENT_AWS_SUCCESS,
      data: result.data
    });
    if (action.callback) {
      action.callback();
    }
  } else {
    yield put({ type: NotifyActionType.NOTIFY_ERROR, data: result.data });
  }
}

export function* uploadLotDocumentToS3Async(action) {
  const paramsUpload = {
    lotId: action.params.lotId,
    file: action.params.file,
    config: action.params.config
  };
  yield call(uploadLotDocumentToS3, paramsUpload, action.callback);
}

export function* uploadLotDocumentToServerAsync(action) {
  const result = yield call(uploadLotDocumentToServer, action.params);
  console.log(result.data, 'data');
  const statusCode = result.statusCode;
  if (statusCode === 200) {
    yield put({
      type: LotActionType.UPLOAD_LOT_DOCUMENT_TO_SERVER_SUCCESS,
      data: result.data
    });
    if (action.callback) {
      action.callback(true, result.data);
    }
  } else {
    if (action.callback) {
      action.callback(false, result.data);
    }
    yield put({ type: NotifyActionType.NOTIFY_ERROR, data: result.data[0] });
  }
}

export function* getLotDocumentAsync(action) {
  const result = yield call(getLotDocument, action.params);
  const statusCode = result.statusCode;
  if (statusCode === 200) {
    yield put({
      type: LotActionType.GET_LOT_DOCUMENT_SUCCESS,
      data: result.data
    });
  } else {
    yield put({ type: NotifyActionType.NOTIFY_ERROR, data: result.data[0] });
  }
}

export function* downloadLotDocumentAsync(action) {
  yield call(downloadLotDocument, action.params, action.callback);
}

export function* removeLotDocumentAsync(action) {
  const result = yield call(removeLotDocument, action.params);
  const statusCode = result.statusCode;
  if (statusCode === 200) {
    yield [
      put({
        type: LotActionType.GET_LOT_DOCUMENT_ASYNC,
        params: {
          lotId: action.params.id
        }
      }),
      put({ type: NotifyActionType.NOTIFY_SUCCESS, data: 'Deleted' })
    ];
  } else {
    yield put({ type: NotifyActionType.NOTIFY_ERROR, data: result.data[0] });
  }
}

// LOT NOTES
export function* getLotNotesAsync(action) {
  const result = yield call(getLotNotes, action.params);
  const statusCode = result.statusCode;
  if (statusCode === 200) {
    yield [
      put({
        type: LotActionType.GET_LOT_NOTES_SUCCESS,
        data: result.data
      })
    ];
  } else {
    yield put({ type: NotifyActionType.NOTIFY_ERROR, data: result.data[0] });
  }
}

export function* addLotNotesAsync(action) {
  const result = yield call(addLotNotes, action.params);
  const statusCode = result.statusCode;
  if (statusCode === 200) {
    yield [
      put({
        type: LotActionType.GET_LOT_NOTES_ASYNC,
        params: {
          lotId: action.params.lotId
        }
      }),
      put({ type: NotifyActionType.NOTIFY_SUCCESS, data: 'Created' })
    ];
    if (action.callback) {
      action.callback();
    }
  } else {
    yield put({ type: NotifyActionType.NOTIFY_ERROR, data: result.data[0] });
  }
}

export function* editLotNotesAsync(action) {
  const result = yield call(editLotNotes, action.params);
  const statusCode = result.statusCode;
  if (statusCode === 200) {
    yield [
      put({
        type: LotActionType.GET_LOT_NOTES_ASYNC,
        params: {
          lotId: action.params.lotId
        }
      }),
      put({ type: NotifyActionType.NOTIFY_SUCCESS, data: 'Saved' })
    ];
    if (action.callback) {
      action.callback();
    }
  } else {
    yield put({ type: NotifyActionType.NOTIFY_ERROR, data: result.data[0] });
  }
}

export function* deleteLotNotesAsync(action) {
  const result = yield call(deleteLotNotes, action.params);
  const statusCode = result.statusCode;
  if (statusCode === 200) {
    yield [
      put({
        type: LotActionType.GET_LOT_NOTES_ASYNC,
        params: {
          lotId: action.params.lotId
        }
      }),
      put({ type: NotifyActionType.NOTIFY_SUCCESS, data: 'Deleted.' })
    ];
  } else {
    yield put({ type: NotifyActionType.NOTIFY_ERROR, data: result.data[0] });
  }
}

export function* checkTenancyExistingByEmailAsync(action) {
  const result = yield call(checkTenancyExistingByEmail, action.params);
  const statusCode = result.statusCode;

  if (statusCode === 200) {
    const { data } = result;
    if (data.hasOwnerOwnerShip) {
      const type = 0; //The email address is the lot's current owner
      action.callback(type, data);
    } else if (data.hasExisted && data.hasBelongBuilder) {
      const type = 1; //The email address appears as a homeowner user that has already been used by current builder
      action.callback(type, data);
    } else if (data.hasExisted && !data.hasBelongBuilder) {
      const type = 2; //The email address appears as an existing user but it has NOT been used by current builder as a homeowner
      action.callback(type, data);
    } else if (!data.hasExisted) {
      const type = 3; //The email address does not exist in entire system
      action.callback(type, data);
    } else if (data.hasTenancy) {
      const type = 4; //The email address is the lot's current tenancy
      action.callback(type, data);
    }
  } else {
    yield put({ type: NotifyActionType.NOTIFY_ERROR, data: result.data.error });
  }
}

export function* setNewLotTenancyAsync(action) {
  const result = yield call(setNewLotTenancy, action.params);
  const statusCode = result.statusCode;

  if (statusCode === 200) {
    yield [put({ type: NotifyActionType.NOTIFY_SUCCESS, data: 'Saved' })];
    if (action.callback) {
      action.callback();
    }
  } else {
    yield put({ type: NotifyActionType.NOTIFY_ERROR, data: result.data.error });
  }
}

export function* inviteLotTenancyAsync(action) {
  const result = yield call(inviteLotTenancy, action.params);
  const statusCode = result.statusCode;

  if (statusCode === 200) {
    yield [put({ type: NotifyActionType.NOTIFY_SUCCESS, data: 'Saved' })];
    if (action.callback) {
      action.callback();
    }
  } else {
    yield put({ type: NotifyActionType.NOTIFY_ERROR, data: result.data.error });
  }
}

export function* setLotPrimaryContactAsync(action) {
  const result = yield call(setLotPrimaryContact, action.params);
  const statusCode = result.statusCode;

  if (statusCode === 200) {
    yield [
      put({
        type: LotActionType.GET_LOT_BY_ID_ASYNC,
        params: action.params.id
      }),
      put({ type: NotifyActionType.NOTIFY_SUCCESS, data: 'Saved' })
    ];
    if (action.callback) {
      action.callback();
    }
  } else {
    yield put({ type: NotifyActionType.NOTIFY_ERROR, data: result.data.error });
  }
}

export function* removeTenancyAsync(action) {
  const result = yield call(removeTenancy, action.params);
  const statusCode = result.statusCode;

  if (statusCode === 200) {
    yield [
      put({
        type: LotActionType.GET_LOT_BY_ID_ASYNC,
        params: action.params.id
      }),
      put({ type: NotifyActionType.NOTIFY_SUCCESS, data: 'Saved' })
    ];
  } else {
    yield put({ type: NotifyActionType.NOTIFY_ERROR, data: result.data.error });
  }
}

export function* getHomeownerLotDocumentAsync(action) {
  const result = yield call(getHomeownerLotDocument, action.params);
  const statusCode = result.statusCode;
  if (statusCode === 200) {
    yield put({
      type: LotActionType.GET_LOT_DOCUMENT_SUCCESS,
      data: result.data
    });
  } else {
    yield put({ type: NotifyActionType.NOTIFY_ERROR, data: result.data[0] });
  }
}

export function* setupHomeownerLotDocumentAWSAsync(action) {
  const result = yield call(setupHomeownerLotDocumentAWS, action.params);
  const statusCode = result.statusCode;
  if (statusCode === 200) {
    yield put({
      type: LotActionType.SETUP_LOT_DOCUMENT_AWS_SUCCESS,
      data: result.data
    });
    if (action.callback) {
      action.callback();
    }
  } else {
    yield put({ type: NotifyActionType.NOTIFY_ERROR, data: result.data });
  }
}

export function* getLotLocationsAsync(action) {
  const result = yield call(getLotLocations, action.params);

  const statusCode = result.statusCode;

  if (statusCode === 200) {
    yield put({
      type: LotActionType.GET_LOT_LOCATIONS_SUCCESS,
      data: result.data
    });
    if (action.callback) {
      action.callback();
    }
  } else {
    yield put({ type: NotifyActionType.NOTIFY_ERROR, data: result.data });
  }
}

export function* getHomeownerLotLocationsAsync(action) {
  const result = yield call(getHomeownerLotLocations, action.params);

  const statusCode = result.statusCode;

  if (statusCode === 200) {
    yield put({
      type: LotActionType.GET_LOT_LOCATIONS_SUCCESS,
      data: result.data
    });
    if (action.callback) {
      action.callback();
    }
  } else {
    yield put({ type: NotifyActionType.NOTIFY_ERROR, data: result.data });
  }
}

export function* getSelectListHomeownerLotAsync(action) {
  const result = yield call(getSelectListHomeownerLot);

  const statusCode = result.statusCode;

  if (statusCode === 200) {
    yield put({
      type: LotActionType.GET_SELECT_LIST_HOMEOWNER_LOT_SUCCESS,
      data: result.data
    });
    if (action.callback) {
      action.callback();
    }
  } else {
    yield put({ type: NotifyActionType.NOTIFY_ERROR, data: result.data });
  }
}

export function* getListHomeownerDocumentTypeAsync(action) {
  const result = yield call(getListHomeownerDocumentType, action.params);

  const statusCode = result.statusCode;

  if (statusCode === 200) {
    yield put({
      type: LotActionType.GET_LIST_HOMEOWNER_DOCUMENT_TYPE_SUCCESS,
      data: result.data
    });
    if (action.callback) {
      action.callback();
    }
  } else {
    yield put({ type: NotifyActionType.NOTIFY_ERROR, data: result.data });
  }
}

export function* getHomeownerDocumentByDocumentTypeAsync(action) {
  const result = yield call(getHomeownerDocumentByDocumentType, action.params);
  console.log('result', result);
  const statusCode = result.statusCode;

  if (statusCode === 200) {
    yield put({
      type: LotActionType.GET_HOMEOWNER_DOCUMENT_BY_DOCUMENT_TYPE_SUCCESS,
      data: result.data
    });
    if (action.callback) {
      action.callback();
    }
  } else {
    yield put({ type: NotifyActionType.NOTIFY_ERROR, data: result.data });
  }
}

export function* exportLotListAsync(action) {
  const result = yield call(exportLotList, action.params);
  const statusCode = result.statusCode;
  if (statusCode === 200) {
    //get file name
    let filename = 'lots.xlsx';
    let disposition = result.headers['content-disposition'];
    if (disposition) {
      let filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
      let matches = filenameRegex.exec(disposition);
      if (matches !== null && matches[1]) {
        filename = matches[1].replace(/['"]/g, '');
      }
    }

    let blob = new Blob([result.data], {
      type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
    });

    if (window.navigator.msSaveOrOpenBlob) {
      // for IE browser
      window.navigator.msSaveOrOpenBlob(blob, filename);
    } else {
      // for Non-IE (chrome, firefox etc.)
      let link = document.createElement('a');
      link.href = window.URL.createObjectURL(blob);
      link.setAttribute('download', filename);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  } else {
    yield put({ type: NotifyActionType.NOTIFY_ERROR, data: result.data[0] });
  }
}

export function* getSelectCostCodeAsync(action) {
  const result = yield call(getSelectCostCode, action.params);

  const statusCode = result.statusCode;

  if (statusCode === 200) {
    yield put({ type: LotActionType.GET_LIST_COST_CODE_SUCCESS, data: result.data });
  } else {
    yield put({ type: NotifyActionType.NOTIFY_ERROR, data: result.data });
  }
}
getHomeownerHomeInventoryCategories;
export function* setAllWarrantyAccessToHomeownerAsync(action) {
  const result = yield call(setAllWarrantyAccessToHomeowner, action.params);

  const statusCode = result.statusCode;

  if (statusCode === 200) {
    yield [
      put({ type: LotActionType.GET_LOT_BY_ID_SUCCESS, data: result.data }),
      put({ type: NotifyActionType.NOTIFY_SUCCESS, data: 'Saved' })
    ];
    if (action.callback) {
      action.callback();
    }
  } else {
    yield put({ type: NotifyActionType.NOTIFY_ERROR, data: result.data });
  }
}
getHomeownerHomeInventoryCategoryItems;
export function* getHomeownerHomeInventoryCategoriesAsync(action) {
  const result = yield call(getHomeownerHomeInventoryCategories, action.params);

  const statusCode = result.statusCode;

  if (statusCode === 200) {
    yield [
      put({ type: LotActionType.GET_LIST_CATEGORY_HOME_INVENTORY_HOME_OWNER_SUCCESS, data: result.data })
    ];
    if (action.callback) {
      action.callback();
    }
  } else {
    yield put({ type: NotifyActionType.NOTIFY_ERROR, data: result.data });
  }
}

export function* getHomeownerHomeInventoryCategoryItemsAsync(action) {
  const result = yield call(getHomeownerHomeInventoryCategoryItems, action.params);

  const statusCode = result.statusCode;

  if (statusCode === 200) {
    yield [
      put({ type: LotActionType.GET_LIST_CATEGORY_ITEM_HOME_INVENTORY_HOME_OWNER_SUCCESS, data: result.data })
    ];
    if (action.callback) {
      action.callback();
    }
  } else {
    yield put({ type: NotifyActionType.NOTIFY_ERROR, data: result.data });
  }
}

export function* getHomeownerHomeInventoryCategoryItemsProfileAsync(action) {
  const result = yield call(getHomeownerHomeInventoryCategoryItemsProfile, action.params);

  const statusCode = result.statusCode;

  if (statusCode === 200) {
    yield [
      put({ type: LotActionType.GET_CATEGORY_ITEM_HOME_INVENTORY_PROFILE_HOME_OWNER_SUCCESS, data: result.data })
    ];
    if (action.callback) {
      action.callback();
    }
  } else {
    yield put({ type: NotifyActionType.NOTIFY_ERROR, data: result.data });
  }
}

export function* editHomeownerHomeInventoryCategoryItemsProfileAsync(action) {
  const result = yield call(editHomeownerHomeInventoryCategoryItemsProfile, action.params);

  const statusCode = result.statusCode;

  if (statusCode === 200) {
    yield [
      put({ type: NotifyActionType.NOTIFY_SUCCESS, data: 'Saved' })
    ];
    if (action.callback) {
      action.callback();
    }
  } else {
    yield put({ type: NotifyActionType.NOTIFY_ERROR, data: result.data });
  }
}

export function* getCategoryProfileDetailsAsync(action) {
  const result = yield call(getCategoryProfileDetails, action.params);
  const statusCode = result.statusCode;

  if (statusCode === 200) {
    yield put({
      type: LotActionType.GET_CATEGORY_PROFILE_DETAILS_HOME_OWNER_SUCCESS, data: result.data
    });
    if (action.callback) {
      action.callback();
    }
  }
  else {
    yield put({ type: NotifyActionType.NOTIFY_ERROR, data: result.data.error });
  }
}

export function* getTaskReminderListForHomeownerAsync(action) {
  const result = yield call(getTaskReminderListForHomeowner, action.params);
  const statusCode = result.statusCode;

  if (statusCode === 200) {
    yield put({
      type: LotActionType.GET_TASK_REMINDER_LIST_FOR_HOMEOWNER_SUCCESS,
      data: result.data
    });
    if (action.callback) {
      action.callback();
    }
  }
  else {
    yield put({ type: NotifyActionType.NOTIFY_ERROR, data: result.data.error });
  }
}

export function* updateTaskReminderWithIdAsync(action) {
  const result = yield call(updateTaskReminderWithId, action.params);
  const statusCode = result.statusCode;

  if (statusCode === 200) {
    yield put({
      type: LotActionType.PATCH_TASK_REMINDER_WITH_ID_SUCCESS,
      data: result.data
    });

    if (action.callback) {
      action.callback();
    }
  }
  else {
    yield put({ type: NotifyActionType.NOTIFY_ERROR, data: result.data });
  }
}

export function* updateTaskReminderWithoutIdAsync(action) {
  const result = yield call(updateTaskReminderWithoutId, action.params);
  const statusCode = result.statusCode;

  if (statusCode === 200) {
    if (action.callback) {
      action.callback();
    }
  }
  else {
    yield put({ type: NotifyActionType.NOTIFY_ERROR, data: result.data });
  }
}

export default function* WatchLots() {
  yield all([
    takeLatest(LotActionType.SEARCH_LOT_ASYNC, searchAsync),
    takeLatest(LotActionType.GET_LOT_BY_ID_ASYNC, getByIdAsync),
    takeEvery(LotActionType.CREATE_LOT_ASYNC, createAsync),
    takeEvery(LotActionType.IMPORT_LOT_ASYNC, importLotAsync),
    takeEvery(LotActionType.UPDATE_LOT_ASYNC, updateAsync),
    takeEvery(LotActionType.SELECT_ROOM_ASYNC, selectRoomAsync),
    takeEvery(LotActionType.SELECT_TRADE_ASYNC, selectTradeAsync),
    takeLatest(LotActionType.GET_LOT_TAB_ASYNC, getLotTabAsync),
    takeLatest(
      LotActionType.CHECK_HOMEOWNER_EXISTING_BY_EMAIL_ASYNC,
      checkHomeownerExistingByEmailAsync
    ),
    takeLatest(LotActionType.INVITE_HOMEOWNER_ASYNC, inviteHomeownerAsync),
    takeLatest(
      LotActionType.SET_OWNERSHIP_TO_LOT_ASYNC,
      setNewOwnershipToLotAsync
    ),
    takeLatest(
      LotActionType.UPDATE_PURCHASE_DATE_TO_LOT_ASYNC,
      updatePurchaseDateToLotAsync
    ),
    takeLatest(
      LotActionType.ADD_MORE_HOMEOWNER_TO_LOT_ASYNC,
      addMoreHomeownerToLotAsync
    ),
    takeLatest(
      LotActionType.RESET_PRIMARY_HOMEOWNER_TO_LOT_ASYNC,
      resetPrimaryHomeownerToLotAsync
    ),
    takeLatest(
      LotActionType.GET_HOMEOWNER_LOT_LIST_ASYNC,
      getHomeownerLotListAsync
    ),
    takeLatest(
      LotActionType.GET_HOMEOWNER_LOT_DETAIL_ASYNC,
      getHomeownerLotDetailAsync
    ),
    takeLatest(LotActionType.SEARCH_RFS_LOT_ASYNC, searchRFSLotAsync),
    takeLatest(
      LotActionType.SEARCH_HOMEOWNER_RFS_LOT_ASYNC,
      searchHomeownerRFSLotAsync
    ),
    takeEvery(
      LotActionType.SETUP_LOT_DOCUMENT_AWS_ASYNC,
      setupLotDocumentAWSAsync
    ),
    takeEvery(
      LotActionType.UPLOAD_LOT_DOCUMENT_TO_S3_ASYNC,
      uploadLotDocumentToS3Async
    ),
    takeEvery(
      LotActionType.UPLOAD_LOT_DOCUMENT_TO_SERVER_ASYNC,
      uploadLotDocumentToServerAsync
    ),
    takeEvery(LotActionType.GET_LOT_DOCUMENT_ASYNC, getLotDocumentAsync),
    takeEvery(
      LotActionType.DOWNLOAD_LOT_DOCUMENT_ASYNC,
      downloadLotDocumentAsync
    ),
    takeEvery(LotActionType.REMOVE_LOT_DOCUMENT_ASYNC, removeLotDocumentAsync),
    takeEvery(LotActionType.GET_LOT_NOTES_ASYNC, getLotNotesAsync),
    takeEvery(LotActionType.ADD_LOT_NOTE_ASYNC, addLotNotesAsync),
    takeEvery(LotActionType.EDIT_LOT_NOTE_ASYNC, editLotNotesAsync),
    takeEvery(LotActionType.DELETE_LOT_NOTE_ASYNC, deleteLotNotesAsync),
    takeLatest(
      LotActionType.CHECK_TENANCY_EXISTING_BY_EMAIL_ASYNC,
      checkTenancyExistingByEmailAsync
    ),
    takeLatest(LotActionType.SET_TENANCY_TO_LOT_ASYNC, setNewLotTenancyAsync),
    takeLatest(LotActionType.INVITE_TENANCY_ASYNC, inviteLotTenancyAsync),
    takeLatest(
      LotActionType.SET_LOT_PRIMARY_CONTACT_ASYNC,
      setLotPrimaryContactAsync
    ),
    takeLatest(LotActionType.REMOVE_TENANCY_ASYNC, removeTenancyAsync),
    takeLatest(
      LotActionType.GET_HOMEOWNER_LOT_DOCUMENT_ASYNC,
      getHomeownerLotDocumentAsync
    ),
    takeLatest(
      LotActionType.SETUP_HOMEOWNER_LOT_DOCUMENT_AWS_ASYNC,
      setupHomeownerLotDocumentAWSAsync
    ),
    takeLatest(LotActionType.GET_LOT_LOCATIONS_ASYNC, getLotLocationsAsync),
    takeLatest(
      LotActionType.GET_HOMEOWNER_LOT_LOCATIONS_ASYNC,
      getHomeownerLotLocationsAsync
    ),
    takeLatest(
      LotActionType.GET_SELECT_LIST_HOMEOWNER_LOT_ASYNC,
      getSelectListHomeownerLotAsync
    ),
    takeLatest(
      LotActionType.GET_LIST_HOMEOWNER_DOCUMENT_TYPE_ASYNC,
      getListHomeownerDocumentTypeAsync
    ),
    takeLatest(
      LotActionType.GET_HOMEOWNER_DOCUMENT_BY_DOCUMENT_TYPE_ASYNC,
      getHomeownerDocumentByDocumentTypeAsync
    ),
    takeLatest(LotActionType.EXPORT_LOT_LIST, exportLotListAsync),
    takeLatest(LotActionType.GET_SUBCONTRACTOR_LOT_ID_ASYNC, getSubcontractorLotDetailAsync),
    takeLatest(LotActionType.GET_LIST_COST_CODE_ASYNC, getSelectCostCodeAsync),
    takeLatest(LotActionType.SET_ALL_WARRANTY_ACCESS_TO_HOMEOWNER_ASYNC, setAllWarrantyAccessToHomeownerAsync),
    takeLatest(LotActionType.GET_LIST_CATEGORY_HOME_INVENTORY_HOME_OWNER_ASYNC, getHomeownerHomeInventoryCategoriesAsync),
    takeLatest(LotActionType.GET_LIST_CATEGORY_ITEM_HOME_INVENTORY_HOME_OWNER_ASYNC, getHomeownerHomeInventoryCategoryItemsAsync),
    takeLatest(LotActionType.GET_CATEGORY_ITEM_HOME_INVENTORY_PROFILE_HOME_OWNER_ASYNC, getHomeownerHomeInventoryCategoryItemsProfileAsync),
    takeLatest(LotActionType.EDIT_CATEGORY_ITEM_HOMEOWNER_ASYNC, editHomeownerHomeInventoryCategoryItemsProfileAsync),
    takeLatest(LotActionType.GET_CATEGORY_PROFILE_DETAILS_HOME_OWNER_ASYNC, getCategoryProfileDetailsAsync),
    takeLatest(LotActionType.GET_TASK_REMINDER_LIST_FOR_HOMEOWNER_ASYNC, getTaskReminderListForHomeownerAsync),
    takeLatest(LotActionType.PATCH_TASK_REMINDER_WITH_ID_ASYNC, updateTaskReminderWithIdAsync),
    takeLatest(LotActionType.PATCH_TASK_REMINDER_WITHOUT_ID_ASYNC, updateTaskReminderWithoutIdAsync)
  ]);
}



// WEBPACK FOOTER //
// ./src/Lots/saga.js